import useRole from '@/hooks/use-role'
import { useIncompleteCount, useToaster } from '@/models/toaster/hooks'
import OnboardButton from './minimized'
import Toaster from './toaster'

const OnboardingToaster = () => {
  const isTenant = useRole() === 'tenant'
  const { open, enabled, hide_completed, setOpen, setEnabled, setHideCompleted } = useToaster()
  const { data, count } = useIncompleteCount()
  if (!enabled || isTenant) return null
  return (
    <>
      {open && (
        <Toaster
          data={data}
          setOpen={setOpen}
          setEnabled={setEnabled}
          hideCompleted={hide_completed}
          setHideCompleted={setHideCompleted}
          count={count}
        />
      )}
      <OnboardButton setOpen={setOpen} count={count} />
    </>
  )
}

export default OnboardingToaster
